module.exports = __webpack_public_path__ + "static/img/paypal-icon.45fb65c2.png";